import React from 'react';
import { Card, Badge } from './ui';
import { CheckCircle, Book, BookOpen, BookMarked, Library, Notebook, BookType, Gift, Sparkles } from 'lucide-react';
export function Product() {
  const tomos = [{
    icon: <Book className="w-8 h-8 text-brand-500" data-id="element-91" data-mp="28cvgw0iwb96v" />,
    color: 'bg-brand-50 border-brand-100',
    label: 'TOMO 1',
    title: 'FUNDAMENTOS Y MENTALIDAD',
    desc: 'La base para mantener tu alimentación durante todo el año.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-lav-500" data-id="element-92" data-mp="2dan6gnw2ij7w" />,
    color: 'bg-lav-50 border-lav-100',
    label: 'TOMO 2',
    title: 'EQUIPAMIENTO, COMPRAS Y ORGANIZACIÓN',
    desc: 'Todo preparado antes de cocinar.'
  }, {
    icon: <BookMarked className="w-8 h-8 text-brand-400" data-id="element-93" data-mp="2n1hunxsvjsvz" />,
    color: 'bg-brand-50 border-brand-100',
    label: 'TOMO 3',
    title: 'EL MÉTODO BATCH COOKING',
    desc: 'Cómo cocinar toda la semana en pocas horas.'
  }, {
    icon: <Library className="w-8 h-8 text-lav-600" data-id="element-94" data-mp="2vz1wb7unfr74" />,
    color: 'bg-lav-50 border-lav-100',
    label: 'TOMO 4',
    title: 'RECETARIO FITNESS DESAYUNOS Y SNACKS',
    desc: 'Empezá cada día con comidas listas.'
  }, {
    icon: <Notebook className="w-8 h-8 text-brand-500" data-id="element-95" data-mp="25i3jz9k2reg7" />,
    color: 'bg-brand-50 border-brand-100',
    label: 'TOMO 5',
    title: 'RECETARIO FITNESS ALMUERZOS Y CENAS',
    desc: 'Comidas completas para mantener tu rutina.'
  }, {
    icon: <BookType className="w-8 h-8 text-lav-500" data-id="element-96" data-mp="2egxbilijtemw" />,
    color: 'bg-lav-50 border-lav-100',
    label: 'TOMO 6',
    title: 'PLANIFICACIÓN ANUAL Y MANTENIMIENTO',
    desc: 'Convertí el Meal Prep en un hábito.'
  }];
  return <section className="py-12 px-4 bg-lav-50 pt-[4px] pb-[4px]" data-id="element-97" data-mp="2t8fnm88aep0z">
      <div className="max-w-5xl mx-auto" data-id="element-98" data-mp="2t9qsychds4u7">
        <div className="text-center mb-10" data-id="element-99" data-mp="2xaaq3g1yf8gc">
          <Badge variant="success" className="mb-4" data-id="element-100" data-mp="2x7g4vmb49jlv">
            🥗 MEAL PREP FITNESS LISTO — 6 TOMOS + 5 BONOS
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-4" data-id="element-101" data-mp="1263852ufafl0">
            EL SISTEMA COMPLETO PARA ORGANIZAR TODA TU ALIMENTACIÓN FITNESS
            DURANTE LA SEMANA.
          </h2>
          <p className="text-lg text-slate-400" data-id="element-102" data-mp="1bw5zkylwblh8">
            Planificás la semana, hacés la compra, cocinás en pocas horas y
            guardás todo porcionado. Cada tomo te lleva paso a paso para dejar
            de improvisar y sostener tu alimentación sin perder tiempo.
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-6 text-sm font-medium text-brand-600" data-id="element-103" data-mp="1lw6jalnog3ly">
            <span data-id="element-104" data-mp="1uv1r226ddlrd">Meal Prep</span> <span className="text-slate-600" data-id="element-105" data-mp="1uvjwnpex9cby">→</span>
            <span data-id="element-106" data-mp="1usxqnu7oj4vu">Batch Cooking</span> <span className="text-slate-600" data-id="element-107" data-mp="1pvxhhafj9m0i">→</span>
            <span data-id="element-108" data-mp="1pwgs062ut84i">Organización</span> <span className="text-slate-600" data-id="element-109" data-mp="1ptunkfb9f8qi">→</span>
            <span data-id="element-110" data-mp="i27jxyvc7et">Constancia</span> <span className="text-slate-600" data-id="element-111" data-mp="hixt4jdgpbv">→</span>
            <span data-id="element-112" data-mp="3rntukohcn3xe">Resultados</span>
          </div>
        </div>

        <div className="mb-10" data-id="element-113" data-mp="3rpergkr4yyyf">
          <h3 className="text-xl font-bold text-ink mb-5 flex items-center gap-3" data-id="element-114" data-mp="275j8oo4gyzs0">
            <Sparkles className="w-8 h-8 text-brand-500" data-id="element-115" data-mp="2c4cpoqiyt8wx" /> 6 TOMOS COMPLETOS
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-116" data-mp="2c670hc0ivkna">
            {tomos.map((tomo, i) => <Card key={i} className={`border ${tomo.color}`} data-id="element-117" data-mp="1yb4ygzysqffr" data-mpi={i}>
                <div className="flex items-start gap-4" data-id="element-118" data-mp="22d89jnhjzi0i">
                  <div className="p-3 bg-white rounded-xl shrink-0 border border-lav-100" data-id="element-119" data-mp="1of1l0xyhuudi">
                    {tomo.icon}
                  </div>
                  <div data-id="element-120" data-mp="1tffu8jbu0ad4">
                    <p className="text-slate-500 text-[11px] font-semibold tracking-widest uppercase mb-1" data-id="element-121" data-mp="1tbi9xudipcrn">
                      {tomo.label}
                    </p>
                    <h4 className="font-bold text-ink text-xl mb-3 leading-tight" data-id="element-122" data-mp="1jggob8igastt">
                      {tomo.title}
                    </h4>
                    <p className="text-slate-400 text-sm leading-relaxed" data-id="element-123" data-mp="3dtpx0y36aab0">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </Card>)}
          </div>
        </div>

        <Card className="bg-white" data-id="element-124" data-mp="2k50nv6zo68fu">
          <h4 className="font-bold text-xl text-ink mb-6" data-id="element-125" data-mp="2k1w9jgshpwbg">Cada tomo incluye:</h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-126" data-mp="2f3bahkoz5iol">
            {['Paso a paso detallado.', 'Planificación semanal.', 'Recetas completas.', 'Organización del freezer y heladera.', 'Cantidades exactas.', 'Consejos prácticos.', 'Aplicación inmediata.', 'Pensado para la vida real.'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-127" data-mp="1wc1woz8687r7" data-mpi={i}>
                <CheckCircle className="w-5 h-5 text-brand-500 shrink-0 mt-0.5" data-id="element-128" data-mp="1rgv00bdbk3bs" />
                <span className="text-slate-300" data-id="element-129" data-mp="1mf5okum6pnn6">{item}</span>
              </div>)}
          </div>
        </Card>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    title: 'SISTEMA VISUAL PREMIUM PARA TUPPERS Y FREEZER',
    desc: 'Etiquetas y organización visual para identificar cada comida, fecha y porción de un vistazo, sin abrir cada tupper.',
    value: '$8.000'
  }, {
    title: 'PANEL DE CONSTANCIA Y DISCIPLINA',
    desc: 'Seguimiento semanal para registrar tus preparaciones, sostener el hábito y ver tu progreso semana a semana.',
    value: '$8.000'
  }, {
    title: 'KIT DE IDENTIDAD VISUAL FITNESS PARA TU COCINA',
    desc: 'Láminas y recordatorios para imprimir y dejar a la vista, que mantienen tu enfoque en la cocina todos los días.',
    value: '$9.000'
  }, {
    title: 'MAPA DE ROTACIÓN HELADERA Y FREEZER',
    desc: 'Qué comer primero, qué congelar y cuánto dura cada preparación para que nada se pierda ni se desperdicie.',
    value: '$8.000'
  }, {
    title: 'CHECKLIST DE RESET SEMANAL',
    desc: 'La rutina de cierre y arranque de semana: limpieza, compra, cocción y porcionado, en una sola lista clara.',
    value: '$9.000'
  }];
  return <section className="py-12 px-4" data-id="element-130" data-mp="2kl3ci4tjnetd">
      <div className="max-w-5xl mx-auto" data-id="element-131" data-mp="2kk1q5472v5wc">
        <div className="text-center mb-8" data-id="element-132" data-mp="2ybf482m7vbjz">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-3 flex items-center justify-center gap-3" data-id="element-133" data-mp="2yb6uukpayodj">
            <Gift className="w-9 h-9 text-brand-500" data-id="element-134" data-mp="2tddlxjwm7g9k" />5 BONOS EXCLUSIVOS
          </h2>
          <p className="text-xl text-brand-600 font-bold uppercase tracking-widest" data-id="element-135" data-mp="25njb17vuw1ry">
            Todo lo que necesitás para organizar tus comidas desde la primera
            semana.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-4 mb-8" data-id="element-136" data-mp="2fmid27m48z5z">
          {bonuses.map((bono, i) => <Card key={i} className={`relative overflow-hidden group hover:border-brand-300 transition-colors lg:col-span-2 ${i === 3 ? 'lg:col-start-2' : ''}`} data-id="element-137" data-mp="2aogt7kgv8vtg" data-mpi={i}>
              <div className="absolute top-0 right-0 bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-138" data-mp="3m3n9el9tzy83">
                BONO {i + 1}
              </div>
              <h4 className="font-bold text-ink text-lg mb-3 pr-12 mt-2" data-id="element-139" data-mp="1cu622dypty7i">
                {bono.title}
              </h4>
              <p className="text-slate-400 text-sm mb-6" data-id="element-140" data-mp="yv6el9mxvpcx">{bono.desc}</p>
              <div className="mt-auto pt-4 border-t border-lav-100 flex justify-between items-center" data-id="element-141" data-mp="13sgbfacnr3as">
                <span className="line-through text-slate-500 text-sm" data-id="element-142" data-mp="1ri0tlr0zlwj0">
                  Valor {bono.value}
                </span>
                <span className="text-brand-600 font-bold" data-id="element-143" data-mp="1hrpgbdveyazg">GRATIS</span>
              </div>
            </Card>)}
        </div>

        <div className="bg-brand-50 border border-brand-200 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-144" data-mp="1mpzbhoh51bl2">
          <p className="text-slate-300 mb-2" data-id="element-145" data-mp="2afbsvbmmcpyg">Valor total bonos</p>
          <p className="text-4xl font-black text-ink mb-2 line-through decoration-brand-400/60" data-id="element-146" data-mp="2f6tl9bakti7t">
            $42.000
          </p>
          <p className="text-2xl font-bold text-brand-600" data-id="element-147" data-mp="f5vn8ar8ptr2">
            → +5 BONOS GRATIS con tu Megapack
          </p>
        </div>
      </div>
    </section>;
}